export { default, EmptySearchResult } from './EmptySearchResult';



// WEBPACK FOOTER //
// ./app/components/search/EmptySearchResult/index.js